module.exports = __webpack_public_path__ + "static/media/p5_s1.9844b3ed.ogg";